import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sc-super-search-dialog',
  templateUrl: './super-search-dialog.component.html',
  styleUrls: ['./super-search-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SuperSearchDialogComponent implements OnInit {
  station: any;
  buttonText: string;
  constructor(public dialogRef: MatDialogRef<SuperSearchDialogComponent>) {}

  ngOnInit() {}
  selectStation(station) {
    this.station = station;
  }
  clearSearch() {
    this.station = null;
  }
}
